'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('riskEventModule')

.factory('grcRiskEventService', ['$http', '$q', function ($http, $q) {
    var baseUrl = environment.apiUrl + '/Pilot/api/RiskEvent';

    var service = {};

    // RiskEvent
    service.getRiskEvent = function (riskEventId) {
        return $http
            .get(baseUrl + '/' + riskEventId)
            .then(function (response) { return response.data; });
    };
    service.createOrUpdateRiskEvent = function (riskEvent) {
        var reqUrl = baseUrl;
        if (!_.isUndefined(riskEvent.RiskEventID)) reqUrl += '/' + riskEvent.RiskEventID;

        return $http
            .post(reqUrl, { RiskEvent: riskEvent })
            .then(function (response) { return response.data; });
    };
    service.deleteRiskEvent = function (riskEventId) {
        return $http
            .delete(baseUrl + '/' + riskEventId)
            .then(function (response) { return response.data; });
    };

    // Related Risks
    service.getRelatedRisks = function (riskEventId) {
        return $http
            .get(baseUrl + '/' + riskEventId + '/Risk')
            .then(function (response) { return response.data; });
    };
    service.addRiskToRiskEvent = function (riskEventId, riskId) {
        return $http
            .post(baseUrl + '/' + riskEventId + '/Risk/' + riskId)
            .then(function (response) { return response.data; });
    };
    service.removeRiskFromRiskEvent = function (riskEventId, riskId) {
        return $http
            .delete(baseUrl + '/' + riskEventId + '/Risk/' + riskId)
            .then(function (response) { return response.data; });
    };

    return service;
}]);
